import { Label, LookupModelSelectionEvent, TableRowDisplayEvent, TableRowMode, Textbox } from "@mcleod/components";
import { AutogenLayoutEquipmentIssued } from "./autogen/AutogenLayoutEquipmentIssued";
import { ModelRow, StringUtil } from "@mcleod/core";
import { LMEUserSettings } from "@mcleod/general";

export class EquipmentIssuedTractor extends AutogenLayoutEquipmentIssued {

    private textboxLocationIdOnLookupModelSelection(event: LookupModelSelectionEvent) {
        const textbox = event.target as Textbox;
        const labelLocationCityState = event.target.parent.findComponentById("labelCityState") as Label;

        const lookupModelData = textbox.getFirstLookupModelData();
        if (!StringUtil.isEmptyString(lookupModelData?.get("id"))) {
            const result = lookupModelData?.get("city_name")
            + ", " + lookupModelData?.get("state");
            labelLocationCityState.setProps({ text: result });
        } else {
            labelLocationCityState.setProps({ text: null });
        }
    }

    tableEquipmentIssuedOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();

        if (!tableRow.data?.isNull("memo")) {
            const textboxMemo = tableRow.findComponentById("textboxMemo") as Textbox;
            textboxMemo.tooltip = textboxMemo.text;
        }

        if (tableRow.mode == TableRowMode.QUICK_ADD) {
            const textboxIssuedBy = tableRow.findComponentById("textboxIssuedUserId") as Textbox;
            const userId = LMEUserSettings.getUserId();
            const userName = LMEUserSettings.getUserName();

            const lookupModelRow = new ModelRow(textboxIssuedBy.lookupModel, true, { id: userId, name: userName });

            if (lookupModelRow != null) {
                const row = textboxIssuedBy.getRelevantModelRow();
                row.setLookupModelData("issued_user_id" , lookupModelRow);

                row.setValues({
                    "issued_user_id": userId,
                    "name": userName
                });
            }

            const textboxStatus = tableRow.findComponentById("textboxStatus") as Textbox;
            const row2 = textboxStatus.getRelevantModelRow();
            row2.setValues({
                "status": "I"
            });

            const textboxLocationId = tableRow.findComponentById("textboxLocationId") as Textbox;

            textboxLocationId.addLookupModelSelectionListener(this.textboxLocationIdOnLookupModelSelection);
        }
    }
}
